export const name = 'gzLocaleSelect';
export default function gzLocaleSelect(
  // Directive angular dependencies
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    require: '^ngModel',
    scope: {
      gzExcludes: '=?',
      gzNative: '@?',
    },
    template: require('./locale-select.jade'),
    link: localeSelectLink,
    controller: localeSelectController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function localeSelectLink(scope, element, attrs, ngModelCtrl) {
    attrs.$observe('required', required => {
      if (required) {
        element.find('md-select')[0].setAttribute('required', '');
      } else {
        element.find('md-select')[0].removeAttribute('required');
      }
      // For some reason, this isn't automatically going to the label also.
      element.find('label').toggleClass('md-required', required);
    });

    // Adapted from https://stackoverflow.com/a/34001183/277307
    scope.vm.setModelValue = () => {
      ngModelCtrl.$setViewValue(scope.vm.selectedLocale);
    };
  }

  /** @ngInject */
  function localeSelectController(
    rnLocale,
    $translate,
    $q
  ) {
    // Constants

    // Variables

    // View Model
    let vm = this;
    vm.selectedLocale = undefined;
    vm.localeOptions = [];
    vm.limitedLocaleOptions = [];

    vm.$onInit = onInit;

    return;

    function onInit() {
      if (!vm.gzNative) {
        vm.gzNative = 'primary';
      }

      return $q.all([
        setInitialLocale(),
        setLocales(),
      ]);
    }

    function setInitialLocale() {
      return rnLocale.getBestFit().then(locale => {
        vm.selectedLocale = locale;
        vm.setModelValue();
      });
    }

    function setLocales() {
      return $translate.onReady().then(() => {
        return rnLocale.localeOptions();
      }).then(locales => {
        vm.localeOptions = _.filter(locales, { limited: false });
        vm.limitedLocaleOptions = _.filter(locales, { limited: true });
        if (vm.gzExcludes) {
          vm.localeOptions = _.filter(vm.localeOptions, locale => {
            return !isExcluded(locale);
          });
          vm.limitedLocaleOptions = _.filter(vm.limitedLocaleOptions, locale => {
            return !isExcluded(locale);
          });
        }

        vm.localeOptions = _.sortBy(vm.localeOptions, locale => {
          return $translate.instant('uxf.uxf.' + locale.value);
        });
        vm.limitedLocaleOptions = _.sortBy(vm.limitedLocaleOptions, locale => {
          return $translate.instant('uxf.uxf.' + locale.value);
        });
      });
    }

    function isExcluded(locale) {
      return _.includes(vm.gzExcludes, locale.value) || _.includes(vm.gzExcludes, getShortName(locale));
    }

    function getShortName(locale) {
      return locale.value.split('-')[0];
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/locale-select/locale-select.directive.js